/** File selection stays in the product form; Shopify uploads on Add to cart. */
class UiProductArtwork extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
  }
  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onClick);
  }
  onChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;
    const file = input.files?.[0];
    let error = '';
    if (file && !/\.(jpe?g|png|webp|pdf)$/i.test(file.name)) error = 'Choose a JPG, PNG, WEBP or PDF file.';
    if (file && file.size > 10 * 1024 * 1024) error = 'Choose a file smaller than 10 MB.';
    if (file && file.size === 0) error = 'This file is empty. Choose another file.';
    input.setCustomValidity(error);
    this.querySelector('[data-artwork-status]').textContent = error || (file ? `${file.name} selected. It will upload when you add these treats to your cart.` : '');
    this.querySelector('[data-artwork-remove]').hidden = !file;
    if (error) input.reportValidity();
  };
  onClick = (event) => {
    if (!event.target.closest('[data-artwork-remove]')) return;
    const input = this.querySelector('input[type="file"]');
    input.value = '';
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.focus();
  };
}
if (!customElements.get('ui-product-artwork')) customElements.define('ui-product-artwork', UiProductArtwork);
